import ClaimsTypes from "@upclaim/prisma/seeds/claims_types.json";
import { ClaimType } from "@/interfaces/data-contracts";

export type ClaimTypeName = ClaimType;

const ClaimsTypesByName = new Map(ClaimsTypes.map(cs => [cs.name as ClaimTypeName, cs]));

function claimTypeByName(name: ClaimTypeName) {
  const claimType = ClaimsTypesByName.get(name);
  if (!claimType) throw `Type error: No claim Type named "${name}"`
  return claimType;
}

function getDisplayName(type: ClaimTypeName, settings?: { emoji: boolean }) : string {
  const includeEmoji = settings?.emoji || false;

  let strObj = { text: '', emoji: '' };
  switch(type) {
    case "FLIGHT_CANCELLATION":
      strObj = { text: 'Annulation', emoji: '❌ ' }
      break;
    case "PNR_SEGMENT_CANCELLATION":
      strObj = { text: 'Annulation Segment', emoji: '🛑 ' }
      break;
    case "FLIGHT_DELAY":
      strObj = { text: 'Retard', emoji: '🕓 ' }
      break;
    case "DELAY_FROM_PNR_SCHEDULE":
      strObj = { text: 'Retard PNR', emoji: '♻️ ' }
      break;
    case "MISSED_CONNECTION_DUE_TO_DELAY":
      strObj = { text: 'Correspondance manquée (Retard)', emoji: "🛄 " }
      break;
    case "CONNECTION_DISRUPTION":
      strObj = { text: 'Rupture de correspondance', emoji: "✂️ " }
      break;
    case "WRONG_ARRIVAL_AIRPORT":
      strObj = { text: 'Mauvais aéroport d\'arrivée', emoji: '📍 ' }
      break;
    case "OVERBOOKING":
      strObj = { text: 'Surbooking', emoji: '🎫 ' }
      break;
    case "COVID_ORDINANCE_2020":
      strObj = { text: 'Ordonnance Covid mars 2020', emoji: '🇫🇷 ' }
      break;
  }

  return (includeEmoji ? strObj.emoji.concat(" ") : "")
    + strObj.text
}

export {
  ClaimsTypes,
  ClaimsTypesByName,
  claimTypeByName,
  getDisplayName
}
